function Avatar(props) {
  const { REACT_APP_IMAGEPATH } = process.env;
  const width = props.width ?? "48";
  const height = props.height ?? "48";
  const url = props.src ?? `${REACT_APP_IMAGEPATH}/generic-avatar.jpg`;
  return (
    <img
      className="ugc-comment__profile-picture"
      alt={`${props.username} avatar`}
      src={`${url}?width=48&autorotate=true`}
      width={width}
      height={height}/>
  );
}

export default Avatar;